/**
 * The member-facing plans page: `/[groupSlug]/plans`.
 *
 * One URL for both “what you pay for” and “pick a plan”. The page chooses which
 * surface to show from membership — a settled member sees their subscription;
 * anyone else sees the picker. “Change plan” flips an in-page mode on the same
 * URL; there is no second route and no query flag.
 */

/** URL segment under [groupSlug]: `/[groupSlug]/plans`. */
export const JOIN_PLANS_ROUTE_SEGMENT = 'plans'

/** Route name registered in `manual-routes.ts`, used with `CPNavigateTo`. */
export const JOIN_PLANS_ROUTE_NAME = 'communities-groups-plans'

/**
 * The membership page segment. Kept as a list so route helpers (e.g. useJoinPlansRoute)
 * can ask “is this a membership surface?” without naming the picker specifically.
 * `/plans` always uses `communities-plans-layout` (see plans.vue definePageMeta).
 */
export const MEMBERSHIP_PAGE_SEGMENTS: readonly string[] = [JOIN_PLANS_ROUTE_SEGMENT]
